import type { Booking } from "../types";

/** Matches Netlify `isBookingSoftDeleted` for client-side snapshot filtering. */
export function isFirestoreBookingSoftDeleted(data: Record<string, unknown>): boolean {
  if (data.active === false) return true;
  if (data.status === "Deleted") return true;
  if (data.deletedAt != null && data.deletedAt !== "") return true;
  return false;
}

/** Replace this client's rows in `globalBookings` so API/snapshot deletes are not kept via merge. */
export function mergeClientBookingsFromServer(
  prev: Booking[],
  principalEmailLower: string,
  mine: Booking[],
): Booking[] {
  const others = prev.filter((b) => (b.userEmail || "").toLowerCase() !== principalEmailLower);
  const byId = new Map<string, Booking>();
  others.forEach((b) => byId.set(b.id, b));
  mine.forEach((b) => byId.set(b.id, b));
  return Array.from(byId.values()).sort((a, bk) => (bk.rawDate || "").localeCompare(a.rawDate || ""));
}

/** Replace rows assigned to this employee so refreshes drop unassigned/archived jobs. */
export function mergeEmployeeAssignedFromServer(
  prev: Booking[],
  employeeEmailLower: string,
  mine: Booking[],
): Booking[] {
  const others = prev.filter((b) => (b.assignedTo || "").toLowerCase() !== employeeEmailLower);
  const byId = new Map<string, Booking>();
  others.forEach((b) => byId.set(b.id, b));
  mine.forEach((b) => byId.set(b.id, b));
  return Array.from(byId.values()).sort((a, bk) => (bk.rawDate || "").localeCompare(a.rawDate || ""));
}
